import React from "react"

function SvgBearjamAvatar(props) {
  return (
    <svg viewBox="0 0 859 988" fill="none" {...props}>
      <path
        d="M429.301 11.002L11 252.507l418.301 241.505 418.302-241.505L429.301 11.001z"
        fill="#6610F2"
      />
      <path
        d="M847.603 252.508L429.301 494.012v483.014l418.302-241.507V252.508z"
        fill="#AF83F8"
      />
      <path
        d="M11 252.508v483.011l418.301 241.507V494.012L11 252.508z"
        fill="#F0B6D3"
      />
      <path
        d="M847.604 252.507V735.52"
        stroke="#fff"
        strokeWidth={1.323}
        strokeLinejoin="round"
      />
      <path
        d="M108.673 387.659c-8.643-5.276-17.49-5.877-17.664 3.579-.194 60.053 0 120.32-.082 180.454-.88 31.902 1.86 67.604 20.484 106.015 20.852 45.283 61.284 83.4 99.193 104.538 6.72 3.881 13.437 7.118 20.046 9.729 28.713 12.002 54.141 10.049 72.953-.833 33.42-18.173 34.292-75.991 10.462-132.364-19.173-47.003-59.64-91.85-99.948-114.092-33.712-21.547-66.303-24.907-89.934-15.155.295-39.147.624-78.275.932-117.415.642-9.232-7.798-19.181-16.441-24.456h-.001zm100.923 188.473c15.892 8.983 31.807 21.932 45.111 38.368 26.287 30.304 43.469 69.726 41.615 99.197-.058 19.653-7.562 33.568-20.143 41.255-23.772 18.399-71.809-1.571-105.954-40.498-26.921-30.068-46.305-70.067-45.107-100.539-1.518-36.707 23.239-56.505 56.466-49.565 8.948 2.431 18.476 6.392 28.012 11.782z"
        fill="#250657"
        stroke="#250657"
        strokeWidth={2.483}
      />
      <path
        d="M429.302 494.013L11 252.507M11 252.507V735.52M11 252.507L429.302 11M429.302 494.013v483.014m0-483.014l418.302-241.506-418.302 241.506zM847.604 735.52V252.507M847.604 252.507L429.302 11M429.302 977.027L847.604 735.52M429.302 977.027L11 735.52"
        stroke="#fff"
        strokeWidth={2.646}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M429.301 11.002L11 252.507l418.301 241.505 418.302-241.505L429.301 11.001z"
        fill="#6610F2"
      />
      <path
        d="M847.603 252.508L429.301 494.012v483.014l418.302-241.507V252.508z"
        fill="#AF83F8"
      />
      <path
        d="M11 252.508v483.011l418.301 241.507V494.012L11 252.508z"
        fill="#F0B6D3"
      />
      <path
        d="M847.604 252.507V735.52"
        stroke="#fff"
        strokeWidth={1.323}
        strokeLinejoin="round"
      />
      <path
        d="M108.673 387.659c-8.643-5.276-17.49-5.877-17.664 3.579-.194 60.053 0 120.32-.082 180.454-.88 31.902 1.86 67.604 20.484 106.015 20.852 45.283 61.284 83.4 99.193 104.538 6.72 3.881 13.437 7.118 20.046 9.729 28.713 12.002 54.141 10.049 72.953-.833 33.42-18.173 34.292-75.991 10.462-132.364-19.173-47.003-59.64-91.85-99.948-114.092-33.712-21.547-66.303-24.907-89.934-15.155.295-39.147.624-78.275.932-117.415.642-9.232-7.798-19.181-16.441-24.456h-.001zm100.923 188.473c15.892 8.983 31.807 21.932 45.111 38.368 26.287 30.304 43.469 69.726 41.615 99.197-.058 19.653-7.562 33.568-20.143 41.255-23.772 18.399-71.809-1.571-105.954-40.498-26.921-30.068-46.305-70.067-45.107-100.539-1.518-36.707 23.239-56.505 56.466-49.565 8.948 2.431 18.476 6.392 28.012 11.782z"
        fill="#250657"
        stroke="#250657"
        strokeWidth={2.483}
      />
      <path
        d="M429.302 494.013L11 252.507M11 252.507V735.52M11 252.507L429.302 11M429.302 494.013v483.014m0-483.014l418.302-241.506-418.302 241.506zM847.604 735.52V252.507M847.604 252.507L429.302 11M429.302 977.027L847.604 735.52M429.302 977.027L11 735.52"
        stroke="#fff"
        strokeWidth={2.646}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgBearjamAvatar

